// Shared "explicit-spend launch" card.
//
// Agent-backed reads (X-Ray Describe, influence tracing) cost real tokens,
// so they never auto-fire — they open ARMED: a card that states what the
// run will do, surfaces the run-shaping controls (model, fuzziness, …) so
// you choose the lens BEFORE spending, and gates the run behind one primary
// button. One card, one idiom, so the two surfaces stay consistent.

import { NOTE_CLASS } from "../lib/ui.js";

const EYEBROW = "text-[11px] leading-[1.08] tracking-[0.06em] uppercase font-medium text-[color:var(--eyebrow)]";

export default function LaunchCard({
    eyebrow,
    description,
    controls = null,
    ctaLabel,
    onLaunch,
    disabled = false,
    disabledHint = null,
}) {
    return (
        <div className="grid min-w-0 pt-[4px]">
            <div className="grid w-full gap-[12px] rounded-[2px] border border-[color:var(--line)] bg-[color:var(--control-bg)] px-[14px] py-[14px] min-w-0">
                {eyebrow ? <div className={EYEBROW}>{eyebrow}</div> : null}
                {description ? (
                    <p className="m-0 text-[12.5px] leading-[1.55] text-[color:var(--muted)] break-words">{description}</p>
                ) : null}
                {controls ? <div className="grid gap-[10px] min-w-0">{controls}</div> : null}
                <div className="flex flex-wrap items-center gap-[10px] pt-[2px]">
                    <button
                        type="button"
                        disabled={disabled}
                        onClick={onLaunch}
                        className="inline-flex h-[30px] items-center rounded-[2px] border border-[color:var(--line-strong)] bg-[color:var(--green-soft)] px-[12px] text-[11px] font-medium uppercase tracking-[0.06em] text-[color:var(--ink)] transition-colors hover:border-[color:var(--green)] disabled:cursor-default disabled:opacity-40 disabled:hover:border-[color:var(--line-strong)] cursor-pointer"
                    >
                        {ctaLabel}
                    </button>
                    {disabled && disabledHint ? <span className={NOTE_CLASS}>{disabledHint}</span> : null}
                </div>
            </div>
        </div>
    );
}
